module.exports = __webpack_public_path__ + "img/cresc_2.edf48acb.png";